import axios from '../utils/axios';

/**
 * SHER-576 — self-service investigation/platform copy.
 * Wires to POST /researcher/investigation/copy/:uuidInvestigation, gated server-side
 * by the COPY_INVESTIGATION permission (SHERWOOD_STAFF). The flags map 1:1 to the
 * SHER-594 backend contract; all default to false = a bare structural copy.
 */
export interface CopyInvestigationRequest {
    /** Name of the new platform. */
    name: string;
    copyDepartments: boolean;
    copyRoles: boolean;
    copyInsuranceField: boolean;
    /** Fresh investigation key for the copy, encrypted under the researcher's raw key. */
    keyResearcherInvestigation: string;
}

export interface CopyInvestigationResponse {
    status: number;
    investigation: { uuid: string; name: string };
}

export function copyInvestigationService(
    uuidInvestigation: string,
    body: CopyInvestigationRequest
): Promise<CopyInvestigationResponse> {
    return new Promise((resolve, reject) => {
        axios
            .post(
                `${import.meta.env.VITE_APP_API_URL}/researcher/investigation/copy/${uuidInvestigation}`,
                body,
                { headers: { Authorization: localStorage.getItem('jwt') } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}
